import { FETCH_EXCEL_FAIL, FETCH_EXCEL_REQUEST, FETCH_EXCEL_SUCCESS } from "../../ActionType/ExcelTypes/ExcelType"

export const excelReducer = (state ={loading:false} , action) => {
    switch (action.type) {
        case FETCH_EXCEL_REQUEST:
            return {
                loading:true,
            }
        case FETCH_EXCEL_SUCCESS:
            return{
                loading:false,
            }
        case FETCH_EXCEL_FAIL:
            return{
                loading:false,
            }
        default:
            return state
    }
}